export const MAX_MESSAGE_FILES = 5
export const MAX_MESSAGE_FILE_SIZE = 50 * 1024 * 1024

export const FALLBACK_MIME_BY_EXTENSION = {
  '.png': 'image/png',
  '.jpg': 'image/jpeg',
  '.jpeg': 'image/jpeg',
  '.pdf': 'application/pdf',
  '.docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  '.xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  '.zip': 'application/zip',
  '.mp4': 'video/mp4',
  '.webm': 'video/webm',
  '.mov': 'video/quicktime',
  '.avi': 'video/x-msvideo',
  '.mkv': 'video/x-matroska',
}

export const ALLOWED_DOCUMENT_MIME_TYPES = new Set([
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/zip',
])

export const DOCUMENT_ACCEPT =
  'application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/zip,.pdf,.docx,.xlsx,.zip'

export const getFileExtension = (name) => {
  const dotIndex = name.lastIndexOf('.')
  return dotIndex === -1 ? '' : name.slice(dotIndex).toLowerCase()
}

export const normalizeAttachmentFile = (file) => {
  if (file.type && file.type !== 'application/octet-stream') return file

  const fallbackMime = FALLBACK_MIME_BY_EXTENSION[getFileExtension(file.name)]
  return fallbackMime ? new File([file], file.name, { type: fallbackMime, lastModified: file.lastModified }) : file
}

export const getAttachmentKind = (file) => {
  if (file.type.startsWith('image/')) return 'image'
  if (file.type.startsWith('video/')) return 'video'
  if (ALLOWED_DOCUMENT_MIME_TYPES.has(file.type)) return 'file'
  return null
}
